import * as React from "react";

function IconClose(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 26 26"
            {...props}
        >
            <path
                d="M15.271 12.341L22 23h-4.294l-4.705-7.601L8.292 23H4l6.7-10.659L4.832 3h4.29l3.879 6.314L16.878 3h4.29z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
}

export default IconClose;
